import { useMemo } from 'react';
import { useOpts } from '../../context';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
function useAmountSelectionButtonText() {
    var getLocalizedString = useGetLocalizedString();
    var _a = useOpts(), allocation = _a.linkTokenPayload.allocation, experiments = _a.experiments;
    var buttonText = useMemo(function () {
        return (allocation === null || allocation === void 0 ? void 0 : allocation.targets.length) > 1 || experiments.confirmationScreenEnabled
            ? getLocalizedString('CONTINUE')
            : getLocalizedString('CONFIRM');
    }, [allocation, getLocalizedString, experiments]);
    return buttonText;
}
export default useAmountSelectionButtonText;
